import { type FC, useEffect, useRef } from 'react';
import {
  type AnimationPlaybackControls,
  motion,
  useAnimate,
} from 'framer-motion';

import { useCountDownEnergyRefill } from '@/components/common/CoolDownEnergyRefill/count-down-energyRefill.hook';

interface LightningIconProps {
  className?: string;
  energy?: number;
}

const LightningIconAnimation: FC<LightningIconProps> = ({
  className,
  energy,
}) => {
  const secondsToAvailable = useCountDownEnergyRefill();
  const [scope, animate] = useAnimate();
  const controllRef = useRef<AnimationPlaybackControls | undefined>();

  useEffect(() => {
    if (energy === undefined) return;

    if (energy < 100 && secondsToAvailable === 0 && !controllRef.current) {
      controllRef.current = animate(
        scope.current,
        {
          scale: [null, 0.8, 0.8, 0.8, 0.5],
          rotate: [null, 20, -20, 20, 0],
        },
        {
          ease: 'linear',
          duration: 1,
          repeat: Infinity,
          repeatDelay: 3,
        },
      );
    }

    if (energy >= 100 && controllRef.current) {
      controllRef.current.cancel();
      controllRef.current = undefined;
    }
  }, [energy, secondsToAvailable]);

  return (
    <motion.svg
      width="106"
      height="133"
      viewBox="0 0 106 133"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <motion.path
        initial={{ scale: 0.5, rotate: 0 }}
        // className="scale-50"
        ref={scope}
        data-figma-bg-blur-radius="16"
        d="M84.9092 0C86.5573 0 87.498 1.88152 86.5092 3.19999L53.4 47.3459C52.4111 48.6644 53.3519 50.5459 55 50.5459H103.035C104.817 50.5459 105.709 52.7002 104.449 53.9601L26.2991 132.11C24.7612 133.648 22.2202 131.972 23.0279 129.953L43.5845 78.5611C44.11 77.2474 43.1425 75.8184 41.7276 75.8184H2.13577C0.708609 75.8184 -0.259296 74.3665 0.289625 73.0491L29.1891 3.69225C30.1207 1.4564 32.3053 0 34.7275 0H84.9092Z"
      />
    </motion.svg>
  );
};

export { LightningIconAnimation };
